import { LockedIcon } from '@sketchnote/icons';
import React from 'react';

export const PrivateTag = (): JSX.Element => {
  return (
    <div className="text-black py-4 px-8 flex bg-yellow-500 rounded-sm text-xs  font-semibold items-center">
      <LockedIcon className="mr-4" />
      <span>Private</span>
    </div>
  );
};
